<template>
  <div class="input-multi-select">
    <div class="row">
      <div class="col-12">
        
      </div>
      <div class="col-6">
        <div class="input-multi-select__label">Available {{ label || 'Options' }} ({{ options.length }})</div>
        <input class="input-multi-select__filter mb-2" type="text" v-model="filterString" placeholder="Search">
      </div>
      <div class="col-6">
        <div class="input-multi-select__label">Selected {{ label || 'Option' }}</div>
      </div>
      <div class="col-6">
        <div class="input-multi-select__options">
          <div
            class="input-multi-select__option"
            v-for="option in filteredOptions"
            :key="option.value"
            @click="selectOption(option)"
          >{{ option.label }}</div>
        </div>
      </div>
      <div class="col-6">
        <div 
          v-if="selectedOption"
          class="input-multi-select__selected-option"
          :key="selectedOption.value"
          @click="unselectOption"
        >{{ selectedOption.label }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import Draggable from 'vuedraggable'
export default {
  components: { Draggable },

  props: ['options', 'value', 'label'],

  data () {
    return {
      filterString: ''
    }
  },

  computed: {
    filteredOptions () {
      return _.filter(this.options, option => {
        if (this.filterString.length) {
          return option.label.toLowerCase().includes(this.filterString.toLowerCase())
        } else {
          return true
        }
      })
    },

    selectedOption: {
      get () {
        // Use the order of selectedOptionValues rather than options, allows draggable to work
        let selectedOption = this.filteredOptions.filter(option => {
          return option.value === this.value
        })
        return selectedOption[0]
      },
      set (selectedOption) {
        this.$emit('input', selectedOption)
      }
    }
  },

  methods: {
    selectOption (option) {
      this.$emit('input', option.value)
    },

    unselectOption () {
      this.$emit('input', null)
    }    
  }

}
</script>
<style lang="scss">
.input-multi-select {
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  padding: 15px;
  // display: flex;

  &__filter{
    border: 1px solid #eee;
    border-radius: 4px;
    padding-left: 0.5em;
  }

  &__label {
    font-weight: 300;
    margin-bottom: 0.5em;
  }

  &__options, &__selected {
    // width: 50%;
    border-radius: 4px;
    height: 200px;
    max-height: 200px;
    overflow: auto;
    border: 1px solid #eee;
    padding: 5px 5px 0;
  }

  &__option, &__selected-option {
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }
}
</style>